export default __webpack_public_path__ + "static/medgas_outlet_w.a43860a8cb8555cf58b7a52de0ea0d5e.svg";